module.exports = "<div #mapElement [style.width]=\"width\" [style.height]=\"height\"></div>\r\n"